import React from "react";
import { Car, Clock, MessageSquare, User, Route as RouteIcon, DollarSign } from "lucide-react";
import AppShell from "@/components/AppShell";
import { useAuth } from "@/lib/auth";

const RIDER_TABS = [
  { to: "/", label: "Ride", icon: Car, end: true },
  { to: "/trips", label: "Trips", icon: Clock },
  { to: "/inbox", label: "Inbox", icon: MessageSquare },
  { to: "/account", label: "Account", icon: User },
];

export function RiderShell({ children, fullBleed }) {
  return (
    <AppShell tabs={RIDER_TABS} accountTo="/account" fullBleed={fullBleed}>
      {children}
    </AppShell>
  );
}

const DRIVER_TABS = [
  { to: "/driver", label: "Drive", icon: Car, end: true },
  { to: "/driver/rides", label: "Rides", icon: RouteIcon, gated: true },
  { to: "/driver/trips", label: "Earnings", icon: DollarSign, gated: true },
  { to: "/driver/inbox", label: "Inbox", icon: MessageSquare, gated: true },
  { to: "/driver/account", label: "Account", icon: User },
];

export function DriverShell({ children, fullBleed }) {
  const { user } = useAuth();
  const locked = user?.role === "driver" && user?.approval_status !== "approved";
  const tabs = DRIVER_TABS.map((t) => (locked && t.gated ? { ...t, disabled: true } : t));
  return (
    <AppShell tabs={tabs} accountTo="/driver/account" fullBleed={fullBleed}>
      {children}
    </AppShell>
  );
}
